const Amounts = [
  {
    id: 'A10',
    label: '$10',
    value: 10,
  },
  {
    id: 'A20',
    label: '$20',
    value: 20,
  },
  {
    id: 'A30',
    label: '$30',
    value: 30,
  },
  {
    id: 'A50',
    label: '$50',
    value: 50,
  },
  {
    id: 'A100',
    label: '$100',
    value: 100,
  },
];

export default Amounts;



// WEBPACK FOOTER //
// ./src/app/components/Contribution/amounts.js